// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__9hee_","infoBtn":"quickbooks_infoBtn__2dETH","formBox":"quickbooks_formBox__2FN0h","formFooter":"quickbooks_formFooter__G9Rwc"};